import { http } from '@/lib/http';
import type { AttributeTemplate } from '@/types/inventory';

const BASE = '/api/v1/tenancy/me/item-attribute-template';

export interface ItemAttributeTemplateResponse {
  itemAttributes: NonNullable<AttributeTemplate['itemAttributes']>;
}

/**
 * Tenant-wide item attribute template. Layered ON TOP of each
 * category's attributeTemplate at item create/update time. On key
 * collision the category template wins (more specific).
 *
 * For now this service only exposes a `get` — the schema is mostly
 * grown organically via the "+ Add attribute" / "Quick custom" flows
 * on the item form. An explicit admin UI for editing/reordering
 * (Inv-attr-admin in BACKLOG) lands later.
 */
export const itemAttributeTemplateService = {
  get: () => http.get<ItemAttributeTemplateResponse>(BASE),
};
